export const getInitials = (user) => {
  if (!user) return "NA";

  const first = user.firstName?.trim()?.[0] || "";
  const last = user.lastName?.trim()?.[0] || "";

  if (first || last) {
    return (first + last).toUpperCase();
  }

  // fallback to name field (if exists)
  if (user.name) {
    const parts = user.name.trim().split(" ");
    return parts
      .slice(0, 2)
      .map((p) => p[0])
      .join("")
      .toUpperCase();
  }

  return "NA";
};

export const getDisplayName = (user) => {
  if (!user) return "Unassigned";

  return `${user.firstName || ""} ${user.lastName || ""}`.trim() || user.name || "Unassigned";
};
